import React from 'react';
import {ThemeAwareSkeleton} from '@components/theme/ThemeAwareSkeleton';

const CollectionProgressCardSkeleton = () => {
    return (
        <div className="card">
            <ThemeAwareSkeleton
                style={{
                    width: '100%',
                    aspectRatio: 1,
                }}
            />
            <div className="card-body">
                <ThemeAwareSkeleton width={100} />
                <div className="row align-items-center">
                    <div className="col">
                        <ThemeAwareSkeleton height={5} />
                    </div>
                    <div className="col-auto ps-0">
                        <ThemeAwareSkeleton width={20} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollectionProgressCardSkeleton;
